import { Config } from 'config';
import { OwnedObject, cloneDeep } from 'gear';

import { Bounds, LazyBoundary, Boundary } from '../../geometry';

import { Xml } from '../../util';
import { Pen, Brush } from '../../style';



export const Region = OwnedObject.extend({ typeName: 'Region',

  init( curves ) {
    this.callParent();
    this._curves = curves;
  },

  get curves() {
    return this.decodeCurves();
  },
  set curves( curves_ ) {
    this._curves = curves_;
  },

  decodeCurves() {
    const curves = this._curves;
    if( Config.lazyCdlDecoding ) {
      const length = curves.length;
      for( let k = 0; k < length; ++k ) {
        const ck = curves[k];
        if( ck.decode ) {
          this._curves[k] = ck.decode();
        }
      }
    }
    return curves;
  },

  clone() {
    return new Region(cloneDeep(this._curves));
  },

  transform( op ) {
    const curves = this.curves;
    //_.forEach(curves,function(c) {
    for(let k=0,kEnd=curves.length;k<kEnd;++k) {
      curves[k].transform(op);
    }//);
  },

  get bounds() {
    return Bounds.ofThings(this.curves) ;
  },
  boundsAfter( transform ) {
    return Bounds.ofThingsAfter(this.curves,transform) ;
  },

  draw( context, transform ) {
    const curves = this.curves;
    //_.forEach(curves,function(c) {
    for(let k=0,kEnd=curves.length;k<kEnd;++k) {
      curves[k].draw(context,transform);
    }//);
  },
  toSVG() {
    let svgCurve = '' ;
    const curves = this.curves;
    //_.forEach(curves,function(c) {
    for(let k=0,kEnd=curves.length;k<kEnd;++k) {
      svgCurve += curves[k].toSVG();
    }//);
    return svgCurve ;
  },

  getFirstPoint() {
    return this.curves[0].getFirstPoint();
  },

  buildXml( node ) {
    Xml.addObject(node,this,'Region');
  },

  setupXml( node ) {
    // The main boundary
    const _curves = this._curves;
    _curves[0].setupXml(node) ;
    for( let k = 1, kEnd = _curves.length; k < kEnd ; ++k ) {
      const hole = Xml.appendElement(node,'Hole');
      _curves[k].setupXml(hole) ;
    }
  }

});

// Because of bacward compatibility, Polyregion.fromXml can return
// several polyregions. This happens when pens and brushes have been defined
// at the region level, something that is currently deprecated.
Region.parseXml = function(node, parentStyle, buildPolyregion) {
  const curves = [];
  curves[0] = Config.lazyCdlDecoding ? new LazyBoundary(node) : Boundary.parseXml(node);
  const holes = Xml.children(node,'Hole');
  //_.forEach(holes, function(h) {
  for(let k=0,kEnd=holes.length;k<kEnd;++k) {
    const h = holes[k];
    curves.push( Config.lazyCdlDecoding ? new LazyBoundary(h) : Boundary.parseXml(h) );
  }//);
  const region = new Region(curves);

  let pen   = Pen.fromXml(node);
  let brush = Brush.fromXml(node);
  if( !pen._empty || !brush._empty ) {
    if( parentStyle.pen ) {
      pen = Pen.def(pen, parentStyle.pen.clone());
    }
    if( parentStyle.brush ) {
      brush = Brush.def(brush, parentStyle.brush.clone());
    }
    buildPolyregion([region],{pen:pen,brush:brush});
    return null;
  }
  else {
    return region;
  }
};

export function mapCurvesToRegions( curves ) {
  var regions = [];
  for( var k = 0, kEnd = curves.length; k < kEnd; ++k ) {
    regions.push( new Region([ curves[k] ]) );
  }
  return regions;
}



/** WEBPACK FOOTER **
 ** ./src/cdl/figure/shape/region.js
 **/